import { TextField } from '@mui/material';

interface EmailFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function EmailField({ value, error, setValue }: EmailFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      required
      label='Email'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default EmailField;

